import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/lib/services/goto";
import { store } from "@/store";

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/pages/LoginPage"),
      meta: { layout: "auth" },
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("@/pages/RegisterPage"),
      meta: { layout: "auth" },
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: () => import("@/pages/ResetPasswordPage"),
      meta: { layout: "auth" },
    },
    {
      path: "/",
      name: "Home",
      component: () => import("@/pages/HomePage"),
      meta: {
        layout: "default",
        requiresAuth: true,
      },
    },
    {
      path: "/accounts",
      name: "Accounts",
      component: () => import("@/pages/AccountsPage"),
      meta: {
        layout: "default",
        requiresAuth: true,
      },
    },
    {
      path: "/categories",
      name: "Categories",
      component: () => import("@/pages/CategoriesPage"),
      meta: {
        layout: "default",
        requiresAuth: true,
      },
    },
    {
      path: "/settings",
      name: "Settings",
      component: () => import("@/pages/SettingsPage"),
      meta: {
        layout: "default",
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
    } else {
      if (store.state.auth.token) {
        try {
          await store.dispatch("fetchProfile");
          next();
        } catch {
          next({ name: "Login" });
        }
      } else {
        next({ name: "Login" });
      }
    }
  } else {
    next();
  }
});
